import { Spinner } from "ui";

const LoadingDots = () => {
  return <Spinner size="sm" />;
};

export default LoadingDots;
